import { render } from "./EventDetailsCard.vue?vue&type=template&id=5c5b7341&scoped=true"
import script from "./EventDetailsCard.vue?vue&type=script&lang=ts"
export * from "./EventDetailsCard.vue?vue&type=script&lang=ts"

import "./EventDetailsCard.vue?vue&type=style&index=0&id=5c5b7341&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c5b7341"

export default script